import { Button, Text, YStack } from '../../Primitives';

type ClerkUnavailableProps = {
  onAction: () => void;
};

export const ClerkUnavailable = ({ onAction }: ClerkUnavailableProps) => (
  <YStack gapY="md" p="md">
    <Text type="h4">Sign-in took a duck dive.</Text>
    <Text color="secondary" type="p-sm">
      A refresh should bring it back up. If it keeps happening, an ad blocker or privacy setting may be the culprit.
    </Text>
    <Button label="Refresh the page" onClick={onAction} />
  </YStack>
);
